/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

import React from 'react';
import { Flex } from 'rebass';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import * as _ from '../../../data/constants.js';

const useStyles = makeStyles(theme => ({
  border: {
    'border-radius': '10px',
    border: '2px solid #EDEDED',
    padding: '8px',
    margin: '24px'
  },
  aligned: {
    display: 'flex',
    flexDirection: 'column',
    'margin-left': 'auto',
    'margin-right': 'auto',
    'align-items': 'center'
  },
  innerElements: {
    'margin-left': '12px',
    'margin-right': '12px'
  },
  inline: {
    display: 'flex',
    flexDirection: 'row',
    'align-items': 'center'
  }
}));

// CURRENTLY UNUSED COMPONENT
// Previous use: for when a patient was completely self starting
const PatientSelfStart = props => {
  const classes = useStyles();

  return (
    <div className={classes.border}>
      <div className={classes.aligned}>
        <div className={classes.innerElements}>
          <Flex p={2}>
            <Typography color="textSecondary">
              You have selected Tidepool Loop in-app tutorial self start. A request will not be sent for this patient to
              receive CPT training.
            </Typography>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default PatientSelfStart;
